import { useCallback, useState } from "react";
import { isLocalDashboard } from "../OrgUsageAnalytics/api";

const STORAGE_KEY = "demo-invites-env";

const isValid = (value) =>
  value === "prod" || value === "dev" || (value === "local" && isLocalDashboard());

/**
 * Environment toggle for Demo Invites. Defaults to Dev because the self-serve
 * demo app reads invites from the dev backend (publicDemoApi on addy-ai-dev).
 */
export function useDemoInvitesEnv() {
  const [env, setEnvState] = useState(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (isValid(stored)) {
        return stored;
      }
    } catch {
      // Storage can be unavailable in private mode; fall back to the default.
    }

    return "dev";
  });

  const setEnv = useCallback((next) => {
    if (!isValid(next)) {
      return;
    }

    setEnvState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // The choice still applies for this page view.
    }
  }, []);

  return [env, setEnv];
}
